<template>
  <div>
    <!--弹出框-->
    <el-form  label-width="auto" class="demo-ruleForm"
      style="height: 100%">
      <el-dialog title="多条件查询" :modal="false" :visible.sync="filterDialogVisible" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="8">
            <el-form-item label="所属省区" prop="sheng">
              <el-select v-model="formData.sheng" placeholder="请选择省" @change="shengChange">
                <el-option v-for="item in shengData" :key="item.regionCode" :label="item.regionName" :value="item.regionCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属市区" prop="shi">
              <el-select v-model="formData.shi" placeholder="请选择市" @change="shiChange">
                <el-option v-for="item in shiData" :key="item.regionCode" :label="item.regionName" :value="item.regionCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属县区" prop="xian">
              <el-select v-model="formData.xian" placeholder="请选择县">
                <el-option v-for="item in xianData" :key="item.regionCode" :label="item.regionName" :value="item.regionCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="淤地坝编码" class="from-el-input-line">
              <el-input type="type" placeholder="淤地坝编码" class="from-el-input" v-model="formData.ydbCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="淤地坝名称" class="from-el-input-line">
              <el-input type="type" placeholder="淤地坝名称" class="from-el-input" v-model="formData.ydbName">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="淤地坝类型" class="from-el-input-line">
              <el-select multiple  placeholder="请选择类型" v-model="formData.ydbLx" @change="ydbLxChange">
                <el-option label="大型坝" value="大型"></el-option>
                <el-option label="中型坝" value="中型"></el-option>
                <el-option label="小型坝" value="小型"></el-option> 
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="是否新建淤地坝" class="from-el-input-line">
              <el-select  placeholder="是否新建淤地坝" v-model="formData.isNewBuild" @change="isNewBuildChange">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="showDelFlagCol">
            <el-form-item type="type" label="是否已销号" class="from-el-input-line">
              <el-select  placeholder="是否已销号" v-model="formData.delFlag" @change="isDelFlagChange">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">淤积专项调查</p>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="是否下游有人" class="from-el-input-line">
              <el-select  placeholder="是否下游有人" v-model="formData.ydbSfxyyr" @change="ydbSfxyyrChange">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="是否有重要设施" class="from-el-input-line">
              <el-select  placeholder="是否有重要设施" v-model="formData.ydbSfyzyss">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="是否百万方以上" class="from-el-input-line">
              <el-select  placeholder="是否百万方以上" v-model="formData.ydbSfbwfys">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="是否16788数据" class="from-el-input-line">
              <el-select  placeholder="是否16788数据" v-model="formData.ydbSf16788Data">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="坝控面积">
              <el-col :span="11">
                <el-form-item>
                  <el-input v-model="formData.bkmj1" placeholder="k㎡" @change="bkmjChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input v-model="formData.bkmj2" placeholder="k㎡" @change="bkmjChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">基于卫星遥感无人机影像获取的指标成果</p>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源" prop="type">
              <el-select v-model="formData.yxsjly" placeholder="请选择数据来源">
                <el-option label="卫星遥感影像" value="0"></el-option>
                <el-option label="无人机影像" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高程基准" prop="type">
              <el-select v-model="formData.yxgcjz" placeholder="请选择高程基准">
                <el-option label="大地高程" value="0"></el-option>
                <el-option label="85高程" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已淤面积">
              <el-col :span="11">
                <el-form-item prop="yymj1">
                  <el-input v-model="formData.yxyymj1" placeholder="k㎡" @change="yxyymjChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="yymj2">
                  <el-input v-model="formData.yxyymj2" placeholder="k㎡" @change="yxyymjChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="剩余库容">
              <el-col :span="11">
                <el-form-item prop="sykr1">
                  <el-input v-model="formData.yxsykr1" placeholder="万m³" @change="yxsykrChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="sykr2">
                  <el-input v-model="formData.yxsykr2" placeholder="万m³" @change="yxsykrChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已淤库容">
              <el-col :span="11">
                <el-form-item prop="yxyykr1">
                  <el-input v-model="formData.yxyykr1" placeholder="万m³" @change="yxyykrChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="yxyykr2">
                  <el-input v-model="formData.yxyykr2" placeholder="万m³" @change="yxyykrChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="坝顶高程">
              <el-col :span="11">
                <el-form-item prop="yxbdgc1">
                  <el-input v-model="formData.yxbdgc1" placeholder="m" @change="yxbdgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="yxbdgc2">
                  <el-input v-model="formData.yxbdgc2" placeholder="m" @change="yxbdgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="淤积高程">
              <el-col :span="11">
                <el-form-item prop="yxyjgc1">
                  <el-input v-model="formData.yxyjgc1" placeholder="m" @change="yxyjgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="yxyjgc2">
                  <el-input v-model="formData.yxyjgc2" placeholder="m" @change="yxyjgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="泄洪设施高程">
              <el-col :span="11">
                <el-form-item prop="yxxhssgc1">
                  <el-input v-model="formData.yxxhssgc1" placeholder="m" @change="yxxhssgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="yxxhssgc2">
                  <el-input v-model="formData.yxxhssgc2" placeholder="m" @change="yxxhssgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="坝体背水面坝脚高程">
              <el-col :span="11">
                <el-form-item prop="yxbjgc1">
                  <el-input v-model="formData.yxbjgc1" placeholder="m" @change="yxbjgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="yxbjgc2">
                  <el-input v-model="formData.yxbjgc2" placeholder="m" @change="yxbjgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">RTK/无人船声呐技术实测获取的指标成果</p>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源">
              <el-select v-model="formData.scsjly" placeholder="请选择数据来源">
                <el-option label="RTK测量" value="0"></el-option>
                <el-option label="RTK测量辅助无人船声呐技术" value="1"></el-option>
                <el-option label="无人机航测辅助无人船声呐技术" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高程基准">
              <el-select v-model="formData.scgcjz" placeholder="请选择高程基准">
                <el-option label="大地高程" value="0"></el-option>
                <el-option label="85高程" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="坝顶高程">
              <el-col :span="11">
                <el-form-item prop="scbdgc1">
                  <el-input v-model="formData.scbdgc1" placeholder="m" @change="scbdgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="scbdgc2">
                  <el-input v-model="formData.scbdgc2" placeholder="m" @change="scbdgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="淤积高程">
              <el-col :span="11">
                <el-form-item prop="scyjgc1">
                  <el-input v-model="formData.scyjgc1" placeholder="m" @change="scyjgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="scyjgc2">
                  <el-input v-model="formData.scyjgc2" placeholder="m" @change="scyjgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="坝体背水面坝脚高程">
              <el-col :span="11">
                <el-form-item prop="scbjgc1">
                  <el-input v-model="formData.scbjgc1" placeholder="m" @change="scbjgcChange1"></el-input>
                </el-form-item>
              </el-col>
              <el-col style="color: #ccc; text-align: center;" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="scbjgc2">
                  <el-input v-model="formData.scbjgc2" placeholder="m" @change="scbjgcChange2"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="高程采集人员姓名" class="from-el-input-line">
              <el-input type="type" placeholder="高程采集人员姓名" class="from-el-input" v-model="formData.scgccjryxm">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="高程采集人员联系方式" class="from-el-input-line">
              <el-input type="type" placeholder="高程采集人员联系方式" class="from-el-input" v-model="formData.scgccjrylxfs">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item type="type" label="高程采集时间" class="from-el-input-line">
              <el-date-picker v-model="formData.scgccjsj" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round type="primary" @click="submit('ruleForm')">确定</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    preApproveYdb,
    initRegion,
    getRegion
  } from '@/api/api.js'
  export default {
    data() {
      return {
        filterDialogVisible: true,
        showDelFlagCol:false,
        formData: {
          sheng: '',
          shi: '',
          xian: '',
          ydbCode: '',
          ydbName: '',
          ydbLx: [], // 初始化淤地坝类型选择数组
          isNewBuild: '', // 初始化是否新建淤地坝的标志
          ydbSfxyyr: '',//是否下游有人
          ydbSfyzyss: '',//是否有重要设施
          ydbSfbwfys: '',//是否百万方以上
          ydbSf16788Data: '',//是否16788数据
          yxsjly:'',
          yxgcjz:'',
          bkmj1:'',
          bkmj2:'',
          yxyymj1:'',
          yxyymj2:'',
          yxsykr1:'',
          yxsykr2:'',
          yxyykr1:'',
          yxyykr2:'',
          yxbdgc1:'',
          yxbdgc2:'',
          yxyjgc1:'',
          yxyjgc2:'',
          yxxhssgc1:'',
          yxxhssgc2:'',
          yxbjgc1:'',
          yxbjgc2:'',
          scsjly:'',
          scgcjz:'',
          scbdgc1:'',
          scbdgc2:'',
          scyjgc1:'',
          scyjgc2:'',
          scbjgc1:'',
          scbjgc2:'',
          scgccjryxm:'',
          scgccjrylxfs:'',
          scgccjsj:'',
          delFlag:''
        },
        rules: {
          ydbLx: [{
            required: true,
            trigger: 'change'
          }],
        },
        //省市县参数
        shengData: null,
        shiData: null,
        xianData: null
      };
    },
    created() {
      //执行initRegion方法，通过接口获取省
      initRegion().then((res) => {
          this.shengData = res.sheng;
          this.shiData = res.shi;
          this.xianData = res.xian 
      });

      const regionCode = this.$store.state.regionCode;
      if('000000' === regionCode){
        this.showDelFlagCol=true;
      }
      
    },
    components: {},
    methods: {
      submit(formName) {
        //这里整理接口参数
        let params = {
          ydbShengCode: this.formData.sheng==''?null:this.formData.sheng,
          ydbShiCode: this.formData.shi==''?null:this.formData.shi,
          ydbXianCode: this.formData.xian==''?null:this.formData.xian,
          ydbCode: this.formData.ydbCode==''?null:this.formData.ydbCode,
          ydbName: this.formData.ydbName==''?null:this.formData.ydbName,
          //ydbSfwggb: this.formData.ydbLx==''?null:this.formData.ydbLx,
          ydbSfwggbs: this.formData.ydbLx==''?null:this.formData.ydbLx,// 使用淤地坝类型数组
          isNewBuild: this.formData.isNewBuild==''?null:Number(this.formData.isNewBuild), // 使用是否新建淤地坝的标志
          delFlag: this.formData.delFlag==''?null:Number(this.formData.delFlag),
          ydbSfxyyr: this.formData.ydbSfxyyr==''?null:Number(this.formData.ydbSfxyyr),
          ydbSfyzyss: this.formData.ydbSfyzyss==''?null:Number(this.formData.ydbSfyzyss),
          ydbSfbwfys: this.formData.ydbSfbwfys==''?null:Number(this.formData.ydbSfbwfys),
          ydbSf16788Data: this.formData.ydbSf16788Data==''?null:Number(this.formData.ydbSf16788Data),
          ydbBkmj1: this.formData.bkmj1==''?null:Number(this.formData.bkmj1),
          ydbBkmj2: this.formData.bkmj2==''?null:Number(this.formData.bkmj2),
          ydbYxSjly: this.formData.yxsjly==''?null:Number(this.formData.yxsjly),
          ydbYxGcjz: this.formData.yxgcjz==''?null:Number(this.formData.yxgcjz),
          ydbYxyymj1: this.formData.yxyymj1==''?null:Number(this.formData.yxyymj1),
          ydbYxyymj2: this.formData.yxyymj2==''?null:Number(this.formData.yxyymj2),
          ydbYxSykr1: this.formData.yxsykr1==''?null:Number(this.formData.yxsykr1),
          ydbYxSykr2: this.formData.yxsykr2==''?null:Number(this.formData.yxsykr2),
          ydbYxYykr1: this.formData.yxyykr1==''?null:Number(this.formData.yxyykr1),
          ydbYxYykr2: this.formData.yxyykr2==''?null:Number(this.formData.yxyykr2),
          ydbYxBdgc1: this.formData.yxbdgc1==''?null:Number(this.formData.yxbdgc1),
          ydbYxBdgc2: this.formData.yxbdgc2==''?null:Number(this.formData.yxbdgc2),
          ydbYxYjgc1: this.formData.yxyjgc1==''?null:Number(this.formData.yxyjgc1),
          ydbYxYjgc2: this.formData.yxyjgc2==''?null:Number(this.formData.yxyjgc2),
          ydbYxXhssgc1: this.formData.yxxhssgc1==''?null:Number(this.formData.yxxhssgc1),
          ydbYxXhssgc2: this.formData.yxxhssgc2==''?null:Number(this.formData.yxxhssgc2),
          ydbYxBjgc1: this.formData.yxbjgc1==''?null:Number(this.formData.yxbjgc1),
          ydbYxBjgc2: this.formData.yxbjgc2==''?null:Number(this.formData.yxbjgc2),
          ydbScSjly: this.formData.scsjly==''?null:Number(this.formData.scsjly),
          ydbScGcjz: this.formData.scgcjz==''?null:Number(this.formData.scgcjz),
          ydbScBdgc1: this.formData.scbdgc1==''?null:Number(this.formData.scbdgc1),
          ydbScBdgc2: this.formData.scbdgc2==''?null:Number(this.formData.scbdgc2),
          ydbScYjgc1: this.formData.scyjgc1==''?null:Number(this.formData.scyjgc1),
          ydbScYjgc2: this.formData.scyjgc1==''?null:Number(this.formData.scyjgc2),
          ydbScBjgc1: this.formData.scbjgc1==''?null:Number(this.formData.scbjgc1),
          ydbScBjgc2: this.formData.scbjgc2==''?null:Number(this.formData.scbjgc1),
          ydbScgccjryxm: this.formData.scgccjryxm.trim()==''?null:this.formData.scgccjryxm.trim(),
          ydbScgccjrylxfs: this.formData.scgccjrylxfs.trim()==''?null:this.formData.scgccjrylxfs.trim(),
          ydbScgccjsj: this.formData.scgccjsj==''?null:this.formatDateForBackend("scgccjsj").split('T')[0]
        };
        this.filterDialogVisible = false;
        this.$emit("getfiltercancel", {
          filterDialogVisible: this.filterDialogVisible
        });
        this.$emit("conditionSearch", params);
      },
      empty() {
        this.filterDialogVisible = false;
        this.$emit("getfiltercancel", {
          filterDialogVisible: this.filterDialogVisible
        });
      },
      handleClose() {
        this.filterDialogVisible = false;
        this.$emit("getfiltercancel", {
          filterDialogVisible: this.filterDialogVisible
        });
      },
      shengChange() {
        if(Array.isArray(this.shiData) && this.shiData.length != 0){
          this.formData.shi = '';
          this.formData.xian = '';
          this.shiData=null;
          this.xianData=null;
        }
        let params = {
            regionCode: this.formData.sheng
        };
        getRegion(params).then((res) => {
          this.shiData = res.data;
        });
      },
      shiChange() {
        if(Array.isArray(this.xianData) && this.xianData.length != 0){
          this.formData.xian = '';
          this.xianData=null;
        }
        let params = {
            regionCode: this.formData.shi
        };
        getRegion(params).then((res) => {
            this.xianData = res.data;
        });
      },
      ydbLxChange(value){
      this.formData.ydbLx = value;
      },
      isNewBuildChange(value){
        this.formData.isNewBuild=value;
      },
      isDelFlagChange(value){
        this.formData.delFlag=value;
      },
      ydbSfxyyrChange(value){
        this.formData.ydbSfxyyr=value;
      },
      bkmjChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'bkmj1');
      },
      bkmjChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'bkmj2');
      },
      yxyymjChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxyymj1');
      },
      yxyymjChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxyymj2');
      },
      yxsykrChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxsykr1');
      },
      yxsykrChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxsykr2');
      },
      yxyykrChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxyykr1');
      },
      yxyykrChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxyykr2');
      },
      yxbdgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxbdgc1');
      },
      yxbdgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxbdgc2');
      },
      yxyjgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxyjgc1');
      },
      yxyjgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxyjgc2');
      },
      yxxhssgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxxhssgc1');
      },
      yxxhssgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxxhssgc2');
      },
      yxbjgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxbjgc1');
      },
      yxbjgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'yxbjgc2');
      },
      scbdgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'scbdgc1');
      },
      scbdgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'scbdgc2');
      },
      scyjgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'scyjgc1');
      },
      scyjgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'scyjgc2');
      },
      scbjgcChange1(value){
        this.judgeIsNumberWarning(value, this.formData, 'scbjgc1');
      },
      scbjgcChange2(value){
        this.judgeIsNumberWarning(value, this.formData, 'scbjgc2');
      },
      judgeIsNumberWarning(value, formData, propertyName){
        if (isNaN(value)) {//输入的不是数字
          formData[propertyName] = ''; 
          this.$message({
            message: "请输入数字",
            type: "error",
        });
        } 
      },
      formatDateForBackend(propertyName) {  
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };  
        let localDateString = this.formData[propertyName].toLocaleDateString('zh-CN', options); 
        let formattedDateString = localDateString.replace(/\//g, '-');
        return formattedDateString;  
      }
    }
  };
</script>

<style scoped="scoped">
.el-dialog {
    width: 1400px;
  }
.el-dialog__body {
    max-height: 600px;
    overflow: auto;
  }
.el-form-item__error {
    padding-top: 0;
  }
.el-input__inner {
    padding-right: 0;
  }
  >>>.el-select .el-tag__close.el-icon-close {
    right: -3px;
  }
  >>>.el-select__tags {
    flex-wrap: nowrap;
    overflow: auto;
  }
  >>>.el-select-dropdown {
    background: transparent !important;
    border: 1px solid #00B3FE;
    background-color: rgba(9, 34, 72, 0.5) !important;
  }
</style>
